import React, { Component } from 'react';
import styled from 'styled-components';
import { Container, MainContent } from '../../components';
import { Trash } from '../../assets/icons';
import { getAttendance, deleteAttendance } from './actions';

export const CommonContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 1rem 1rem 3rem;
  color: var(--text);
  overflow-x: auto;
`;

const StyledImg = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;
  margin: 2rem auto 3rem;
  display: block;
`;

const Title = styled.h1`
  text-align: center;
  font-family: var(--text-title);
  color: var(--text);
  margin: 1rem 0;
  font-size: 2rem;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2rem;
  cursor: default;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    white-space: nowrap;
  }

  th {
    background-color: var(--background-alt, #f5f5f5);
    font-weight: bold;
  }
`;

class Attendance extends Component {
  state = {
    attendance: [],
  };

  async componentDidMount() {
    this.refreshAttendance();
  }

  refreshAttendance = async () => {
    const { data } = await getAttendance();
    this.setState({ attendance: data || [] });
  };

  handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de que quieres borrar este registro?')) {
      await deleteAttendance(id);
      this.refreshAttendance();
    }
  };

  render() {
    return (
      <Container>
        <MainContent style={{ maxWidth: '1000px' }}>
          <CommonContainer>
            <StyledTable>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Fecha</th>
                  <th>Orden</th>
                  <th>Nombre</th>
                  <th>Asiste</th>
                  <th>Autobús</th>
                  <th>Menú niño</th>
                  <th>Intolerancias / Alergias</th>
                  <th>Borrar</th>
                </tr>
              </thead>
              <tbody>
                {this.state.attendance
                  .sort((a, b) => {
                    const dateA = new Date(a.createdAt).toLocaleDateString();
                    const dateB = new Date(b.createdAt).toLocaleDateString();
                    if (dateA === dateB) return a.position - b.position;
                    return new Date(a.createdAt) - new Date(b.createdAt);
                  })
                  .map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{new Date(item.createdAt).toLocaleString()}</td>
                      <td style={{ textAlign: 'center' }}>{item.position}</td>
                      <td>{item.name}</td>
                      <td>{item.attending ? 'Sí' : 'No'}</td>
                      <td>{item.bus ? item.bus.charAt(0).toUpperCase() + item.bus.slice(1) : '-'}</td>
                      <td style={{ textAlign: 'center' }}>{item.isChildMenu ? 'Infantil' : '-'}</td>
                      <td style={{ whiteSpace: 'wrap', minWidth: '300px' }}>{item.foodCondition || '-'}</td>
                      <td style={{ width: '40px', textAlign: 'center' }}>
                        <div
                          style={{ cursor: 'pointer', display: 'inline-flex', padding: '5px' }}
                          onClick={() => this.handleDelete(item.id)}
                        >
                          <Trash color="#e74c3c" size={20} />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </StyledTable>
          </CommonContainer>
        </MainContent>
      </Container>
    );
  }
}

export default Attendance;
